import { Link } from 'react-router-dom';
import { specialTopics } from '@/mocks/data';

export default function SpecialTopics() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100/60">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-2">
            特色专题
          </h2>
          <p className="text-sm text-foreground-500">精心策划 · 发现更多好内容</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {specialTopics.map((topic) => (
            <Link
              key={topic.id}
              to={`/category/hot`}
              className="group relative aspect-[16/9] rounded-lg overflow-hidden cursor-pointer"
            >
              <img
                src={topic.image}
                alt={topic.title}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <h3 className="text-sm font-semibold text-background-50 mb-1 whitespace-nowrap">{topic.title}</h3>
                <p className="text-xs text-background-50/75 mb-2">{topic.description}</p>
                <span className="text-xs text-background-50/60 whitespace-nowrap">{topic.count} 部作品</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}